import { render, staticRenderFns } from "./ServicePage.vue?vue&type=template&id=43549e1d&"
import script from "./ServicePage.vue?vue&type=script&lang=ts&"
export * from "./ServicePage.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports